import { c as _c } from "react/compiler-runtime";
import useCartLoading from '@/contexts/cartContext/hooks/useCartLoading';
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import usePageFormErrors from '@/contexts/pageContext/hooks/usePageFormErrors';
import { FGTMEventEnum } from '@/types/gtm';
import { BPaymentBehaviourEnum } from '@/types/temp';
import getGTMECommerce from '@/utils/gtm/getGTMECommerce';
import pushGTMDataLayer from '@/utils/gtm/pushGTMDataLayer';
import { Button } from '@winelidays/wld-tsx-2/elements';
import useTunnelBookingType from '../../context/hooks/useTunnelBookingType';
import useTunnelExperience from '../../context/hooks/useTunnelExperience';
const AddToCartButton = t0 => {
    const $ = _c(22);
    const { formId, onClick, calculatedPrice, reservationInProgress } = t0;
    const translate = useTranslate();
    const { _key: currencyKey } = useCurrency();
    const { experience } = useTunnelExperience();
    const bookingType = useTunnelBookingType();
    const t1 = calculatedPrice?.feesBeforeTax ?? null;
    const t2 = calculatedPrice?.total ?? null;
    let t3;
    if ($[0] !== t1 || $[1] !== t2) {
        t3 = {
            feesBeforeTax: t1,
            totalPrice: t2
        };
        $[0] = t1;
        $[1] = t2;
        $[2] = t3;
    }
    else {
        t3 = $[2];
    }
    const { feesBeforeTax, totalPrice } = t3;
    const paymentBehaviour = totalPrice == null || totalPrice > 0 ? BPaymentBehaviourEnum.Checkout : BPaymentBehaviourEnum.Free;
    const loadingCart = useCartLoading();
    const { setShowFormErrors, isFormInError, loadingFormErrors } = usePageFormErrors(formId);
    let t4;
    if ($[3] !== setShowFormErrors) {
        t4 = () => {
            setShowFormErrors(true);
        };
        $[3] = setShowFormErrors;
        $[4] = t4;
    }
    else {
        t4 = $[4];
    }
    const handleShowFormErrors = t4;
    const disabledButton = loadingFormErrors || isFormInError;
    let t5;
    if ($[5] !== translate) {
        t5 = translate("messages.continue");
        $[5] = translate;
        $[6] = t5;
    }
    else {
        t5 = $[6];
    }
    const buttonLabel = t5;
    let t6;
    if ($[7] !== bookingType || $[8] !== currencyKey || $[9] !== experience || $[10] !== feesBeforeTax || $[11] !== onClick || $[12] !== paymentBehaviour || $[13] !== reservationInProgress || $[14] !== totalPrice) {
        t6 = e => {
            const newDataLayer = getGTMECommerce({
                bookingType,
                conversionAmount: feesBeforeTax,
                currencyKey,
                discount: null,
                experience,
                paymentBehaviour,
                reservationInProgress,
                totalPrice
            });
            pushGTMDataLayer({
                ...newDataLayer,
                event: FGTMEventEnum.add_to_cart
            });
            onClick(e);
        };
        $[7] = bookingType;
        $[8] = currencyKey;
        $[9] = experience;
        $[10] = feesBeforeTax;
        $[11] = onClick;
        $[12] = paymentBehaviour;
        $[13] = reservationInProgress;
        $[14] = totalPrice;
        $[15] = t6;
    }
    else {
        t6 = $[15];
    }
    const handleClick = t6;
    let t7;
    if ($[16] !== buttonLabel || $[17] !== disabledButton || $[18] !== handleClick || $[19] !== handleShowFormErrors || $[20] !== loadingCart) {
        t7 = <Button title={buttonLabel} busy={loadingCart} disabled={disabledButton} onDisabledClick={handleShowFormErrors} onClick={handleClick} className="btn-primary !px-4 !py-3 xxs:!py-4 inline-block m-6 self-stretch mx-4 xxs:min-w-75 xxs:mx-auto max-w-full lg:min-w-initial lg:mx-6 lg:self-stretch mt-2">{buttonLabel}</Button>;
        $[16] = buttonLabel;
        $[17] = disabledButton;
        $[18] = handleClick;
        $[19] = handleShowFormErrors;
        $[20] = loadingCart;
        $[21] = t7;
    }
    else {
        t7 = $[21];
    }
    return t7;
};
export default AddToCartButton;
